// extracted by mini-css-extract-plugin
export var container = "_s7-0";
export var inputWidth = "_s7-1";